import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createBlock as _createBlock, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3acc682d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "goods-sort-list-box" }
const _hoisted_2 = {
  key: 0,
  class: "goods-pro-list-box"
}
const _hoisted_3 = {
  key: 1,
  class: "goods-category-list-box"
}
const _hoisted_4 = { class: "goods-category-count-box" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "goods-category-left-box" }, "显示个数", -1))
const _hoisted_6 = { class: "goods-category-right-box" }
const _hoisted_7 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_8 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_9 = {
  key: 0,
  style: {"padding-left":"25px"}
}
const _hoisted_10 = { style: {"display":"flex","align-items":"center"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_ui_layout2 = _resolveComponent("ui-layout2")!
  const _component_edit_goods_list = _resolveComponent("edit-goods-list")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_ui_tag_deco = _resolveComponent("ui-tag-deco")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_ui_layout1 = _resolveComponent("ui-layout1")!
  const _component_el_color_picker = _resolveComponent("el-color-picker")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_ui_layout2, {
      title: "添加商品",
      class: "view-item-box"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_radio_group, {
          modelValue: _ctx.modelValue.goods_type,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modelValue.goods_type) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio, { label: "goods" }, {
              default: _withCtx(() => [
                _createTextVNode("商品")
              ]),
              _: 1
            }),
            _createVNode(_component_el_radio, { label: "category" }, {
              default: _withCtx(() => [
                _createTextVNode("商品分组")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.modelValue.goods_type == 'goods')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_edit_goods_list, {
              modelValue: _ctx.modelValue.goodsIds,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modelValue.goodsIds) = $event))
            }, null, 8, ["modelValue"]),
            _createElementVNode("div", {
              class: "add-goods-pro-box",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addGoods && _ctx.addGoods(...args)))
            }, [
              _createVNode(_component_el_icon, { size: "24" }, {
                default: _withCtx(() => [
                  _createVNode(_component_Plus)
                ]),
                _: 1
              })
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_ctx.modelValue.category)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_ui_tag_deco, {
                    onEdit: _ctx.addGoodsCategory,
                    onDelete: _cache[3] || (_cache[3] = ($event: any) => (_ctx.modelValue.category = null))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.modelValue.category.name), 1)
                    ]),
                    _: 1
                  }, 8, ["onEdit"]),
                  _createElementVNode("div", _hoisted_4, [
                    _hoisted_5,
                    _createElementVNode("div", _hoisted_6, [
                      _createTextVNode(" 最多显示 50 个 "),
                      _createVNode(_component_el_input_number, {
                        modelValue: _ctx.modelValue.category.count,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.modelValue.category.count) = $event)),
                        min: 1,
                        max: 50
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ], 64))
              : (_openBlock(), _createBlock(_component_el_button, {
                  key: 1,
                  onClick: _ctx.addGoodsCategory
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("添加商品分组")
                  ]),
                  _: 1
                }, 8, ["onClick"]))
          ]))
    ]),
    _createVNode(_component_ui_layout2, { title: "列表样式" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_radio_group, {
          modelValue: _ctx.modelValue.listMode,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.modelValue.listMode) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_button, { label: "small" }, {
              default: _withCtx(() => [
                _createTextVNode("小图")
              ]),
              _: 1
            }),
            _createVNode(_component_el_radio_button, { label: "big" }, {
              default: _withCtx(() => [
                _createTextVNode("大图")
              ]),
              _: 1
            }),
            _createVNode(_component_el_radio_button, { label: "minix" }, {
              default: _withCtx(() => [
                _createTextVNode("一大两小")
              ]),
              _: 1
            }),
            _createVNode(_component_el_radio_button, { label: "list" }, {
              default: _withCtx(() => [
                _createTextVNode("列表")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }),
    (_ctx.modelValue.listMode == 'small')
      ? (_openBlock(), _createBlock(_component_ui_layout2, {
          key: 0,
          title: "每行个数"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.modelValue.rowCount,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.modelValue.rowCount) = $event)),
              placeholder: "请输入每行个数，不写是为2"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_el_divider),
    _createVNode(_component_ui_layout1, { class: "view-item-box" }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_el_checkbox, {
            modelValue: _ctx.modelValue.showTitle,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.modelValue.showTitle) = $event)),
            "true-label": 1,
            "false-label": 0
          }, {
            default: _withCtx(() => [
              _createTextVNode("显示标题")
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_ui_layout1, { class: "view-item-box" }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_el_checkbox, {
            modelValue: _ctx.modelValue.showBuyBtn,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.modelValue.showBuyBtn) = $event)),
            "true-label": 1,
            "false-label": 0
          }, {
            default: _withCtx(() => [
              _createTextVNode("显示购买按钮")
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]),
      content: _withCtx(() => [
        (_ctx.modelValue.showBuyBtn)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, i) => {
                return (_openBlock(), _createBlock(_component_el_radio, {
                  modelValue: _ctx.modelValue.btnStyle,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.modelValue.btnStyle) = $event)),
                  label: item.value,
                  key: i
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.name), 1)
                  ]),
                  _: 2
                }, 1032, ["modelValue", "label"]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_ui_layout1, { class: "view-item-box" }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_el_checkbox, {
            modelValue: _ctx.modelValue.showPrice,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.modelValue.showPrice) = $event)),
            "true-label": 1,
            "false-label": 0
          }, {
            default: _withCtx(() => [
              _createTextVNode("显示价格")
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_el_divider),
    _createVNode(_component_ui_layout2, { title: "商品标签" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_input, {
          modelValue: _ctx.modelValue.tagText,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.modelValue.tagText) = $event)),
          placeholder: "不填则不显示",
          style: {"width":"160px"},
          clearable: ""
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }),
    (_ctx.modelValue.tagText)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(_component_ui_layout2, {
            title: "标签背景色",
            ext: _ctx.modelValue.tagBgColor ? '' : '默认主色'
          }, {
            default: _withCtx(() => [
              (_ctx.modelValue.tagBgColor)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    type: "text",
                    style: {"margin":"0 10px 0 0"},
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.modelValue.tagBgColor = ''))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("重置")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_el_color_picker, {
                modelValue: _ctx.modelValue.tagBgColor,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.modelValue.tagBgColor) = $event)),
                onActiveChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.modelValue.tagBgColor = $event)),
                "show-alpha": ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["ext"]),
          _createVNode(_component_ui_layout2, {
            title: "标签文字色",
            ext: _ctx.modelValue.tagTextColor ? '' : '默认辅色'
          }, {
            default: _withCtx(() => [
              (_ctx.modelValue.tagTextColor)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    type: "text",
                    style: {"margin":"0 10px 0 0"},
                    onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.modelValue.tagTextColor = ''))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("重置")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_el_color_picker, {
                modelValue: _ctx.modelValue.tagTextColor,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.modelValue.tagTextColor) = $event)),
                onActiveChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.modelValue.tagTextColor = $event)),
                "show-alpha": ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["ext"])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}